export default {
  ScreenshotSuccess: "Screenshot saved successfully",
  ScreenshotFailed: "Screenshot failed",
  Download: "Download",
  ECVScreenshot: "ECV Screenshot",
  WholeScreenshot: "Whole Screenshot",
  self: "Self",
  hidden: "Hidden",
  visible: "Visible",
  "admin-panel": "Admin Panel",
  agent: "Agent",
  supervisor: "Supervisor",
  "ecv-window": "ECV Window",
  "whole-screens": "Whole Screens",
};
